<template>
  <div :class="elementClass">
    <mad-card>
      <slot></slot>
    </mad-card>
  </div>
</template>

<script>
import { dataTableClass } from "../prefix";
export default {
  computed: {
    elementClass() {
      return dataTableClass;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-datatable";

#{$element} {
  margin-bottom: 20px;
  overflow: hidden;
  table {
    width: 100%;
    border-spacing: 0;
    thead {
      tr {
        height: 30px;
        border-spacing: 0;
      }
    }
    th {
      text-align: left;
      text-transform: uppercase;
      font-size: 10px;
      line-height: 40px;
      height: 48px;
      color: $color-grey-600;
      // background: $color-grey-100;
      border-bottom: 1px solid #e6e7eb;
      padding: 0 16px;
      white-space: none;
    }

    tbody {
      tr {
        height: 44px;
        &:last-child {
          border-bottom: none;
        }
      }
    }

    td {
      color: $color-grey-800;
      background: $color-white;
      font-size: 12px;
      padding: 0 16px;
      height: 56px;
      border-bottom: 1px solid #e6e7eb;
    }

    tr {
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
